// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-73501540] .panel-body {\n  flex-grow: 1;\n}", ""]);
// Exports
module.exports = exports;
